import React from "react";
import useStyles from "../../../../styles";
import { ReactComponent as SubjectIcon } from "../../../images/DashboardIcon/totalsubject.svg";
import { ReactComponent as LearnerIcon } from "../../../images/DashboardIcon/totallearner.svg";
import { ReactComponent as TeacherIcon } from "../../../images/DashboardIcon/totalteacher.svg";
import { ReactComponent as PublishedIcon } from "../../../images/DashboardIcon/totalpublished.svg";
import { ReactComponent as BooksIcon } from "../../../images/DashboardIcon/totalbooks.svg";
import { ReactComponent as ExamIcon } from "../../../images/DashboardIcon/totalexam.svg";
import { Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";


// Clean card design for two cards
const useCardStyles = makeStyles((theme) => ({
  // container: {
  //   display: "grid",
  //   gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  //   gap: "20px",
  //   width: "100%",
  // },
  container: {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "20px",
  width: "100%",

  "@media (max-width: 768px)": {
    gridTemplateColumns: "1fr", 
  },
},
  
  card: {
    background: "#ffffff",
    borderRadius: 20,
    padding: "32px 24px",
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    border: "1px solid #f1f5f9",
    transition: "all 0.3s ease",
    // cursor: "pointer",
    height: "160px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
      "& $icon": {
        transform: "scale(1.1)",
      },
    },
  },
  icon: {
    width: 48,
    height: 48,
    color: "#64748b",
    marginBottom: 16,
    transition: "transform 0.3s ease",
    "& svg": {
      width: "100%",
      height: "100%",
    },
  },
  title: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: 8,
    lineHeight: 1.2,
  },
  value: {
    fontSize: "2rem",
    fontWeight: 700,
    color: "#1e293b",
    lineHeight: 1,
  },
}));

function TotalData({ dashboardData, cardData }) {
  const classes = useStyles();
  const cardStyles = useCardStyles();

  return (
    <div className={cardStyles.container}>
      {cardData?.map((data, ind) => (
        <div key={ind} className={cardStyles.card}>
          <div className={cardStyles.icon}>
            {data?.icon}
          </div>
          <Typography className={cardStyles.title}>
            {data?.title || data?.label}
          </Typography>
          <Typography className={cardStyles.value}>
            {data?.value || 0}
          </Typography>
        </div>
      ))}
    </div>
  );
}

export default TotalData;
